export const FORM_PREORDER_NAME = 'DetailsPreorder';
export const PREORDER_FIELD_FIO = 'name';
export const PREORDER_FIELD_PHONE = 'phone';
export const PREORDER_FIELD_EMAIL = 'email';
export const PREORDER_FIELD_AGREEMENT = 'agreement';
export const PREORDER_PAYMENT_AGREEMENT = 'paymentAgreement';
/* takeaway popup form constants */
export const FORM_TAKEAWAY_NAME = 'TakeawayAction';
export const TAKEAWAY_FIELD_FIO = 'name';
export const TAKEAWAY_FIELD_PHONE = 'phone';
export const TAKEAWAY_FIELD_EMAIL = 'email';
